/**
 * Controller for sections/main-product-custom-photo.liquid.
 * Extracted from the source section's inline script block, because this theme uses
 * the javascript Liquid tag in no section or snippet. Behaviour is unchanged: it
 * already resolves the section document-wide rather than via currentScript.
 */
  (function () {
    // Resolve the section element document-wide. Shopify bundles all {% javascript %}
    // into ONE script whose currentScript.parentElement is NOT this section, so a
    // scoped lookup would miss it and section.classList would throw on `document`.
    const section = document.querySelector('.page-content--product') || document;
    const cropper = section.querySelector('photo-cropper');
    const frameStackHost = section.querySelector('[data-frame-stack-host]');
    const frameStack = frameStackHost ? frameStackHost.querySelector('frame-stack') : null;
    const artImg = frameStack ? frameStack.querySelector('.frame-stack__art') : null;
    const form = section.querySelector('form[action*="/cart/add"]') || section.querySelector('form');
    if (!cropper || !form) return;

    const fileInput = form.querySelector('[data-photo-file-input]');
    const cropMetaInput = form.querySelector('[data-photo-crop-meta]');
    const propFilter = form.querySelector('[data-prop-filter]');
    const propFont = form.querySelector('[data-prop-font]');
    const propBorder = form.querySelector('[data-prop-border]');
    const propRotation = form.querySelector('[data-prop-rotation]');
    const headlineInput = form.querySelector('[data-headline]');
    const subtitleInput = form.querySelector('[data-subtitle]');
    const addToCart = section.querySelector('[data-add-to-cart]');
    // Matches the theme's medium-up stacking point; drives the mobile flow (option
    // order, closed-by-default accordions, sticky buy bar).
    const mqMobile = window.matchMedia('(max-width: 768px)');
    const customizer = section.querySelector('[data-customizer]');

    const doneBtn = section.querySelector('[data-action="done-cropping"]');
    const editBtn = section.querySelector('[data-action="edit-crop"]');
    const changeBtn = section.querySelector('[data-action="change-photo"]');
    const photoActions = section.querySelector('[data-photo-actions]');
    const cropControls = section.querySelector('[data-crop-controls]');
    const zoomSlider = section.querySelector('[data-action="zoom"]');
    const rotateBtn = section.querySelector('[data-action="rotate"]');
    const filterStrip = section.querySelector('[data-filter-strip]');
    const fontBtns = Array.from(section.querySelectorAll('[data-font]'));
    const borderBtns = Array.from(section.querySelectorAll('[data-border]'));
    const qualityBtn = section.querySelector('[data-quality-open]');
    const qualityModal = section.querySelector('[data-quality-modal]');
    const qualityList = section.querySelector('[data-quality-list]');
    const qualityBar = section.querySelector('[data-quality-bar]');
    const qualityValue = section.querySelector('[data-quality-value]');

    // No letter-case option: the caption prints exactly as the customer typed it. The page
    // used to capitalise unconditionally, which turned every name into a shout, and the
    // "Som skrevet / STORE BOGSTAVER" toggle that replaced it was one decision too many for
    // something a customer can just type the way they want it.
    const state = { filter: 'original', font: 'modern', border: 'none' };

    const accordions = Array.from(section.querySelectorAll('[data-accordion-toggle]')).map(function (head) {
      return { head: head, panel: head.parentElement.querySelector('[data-accordion-panel]') };
    });


    // ---- Option roles ------------------------------------------------------
    // Option names and values are translatable, so nothing here may match on them. The
    // section renders the radios with these stable names and, for orientation, a
    // data-orientation="P|L" attribute. See the comment block at the top of
    // sections/main-product-custom-photo.liquid for the positional contract.
    const SIZE_RADIO_NAME = 'cp-option1';
    const ORI_RADIO_NAME = 'cp-option2';
    const OPTION_RADIO_RE = /^cp-option(\d+)$/;

    function checkedOption(name) {
      return section.querySelector('input[name="' + name + '"]:checked');
    }
    function orientationIsLandscape() {
      const r = checkedOption(ORI_RADIO_NAME);
      return !!(r && r.getAttribute('data-orientation') === 'L');
    }

    // ---- Image quality per size (Billedkvalitet modal) ---------------------
    // Sizes mirror the size options + their cm dimensions (see applyAspect). `label` is only
    // a fallback: sizeLabel() prefers the radio's own value, which is whatever the merchant
    // and the translation say.
    //
    // `target` / `floor` are the DPI the FINISHED PRINT should have, and they fall as the
    // poster grows: a B1 hangs across a room and a A4 is read at arm's length, so the same
    // DPI does not buy the same perceived sharpness. `target` = comfortably sharp,
    // `floor` = below this the customer is warned.
    const QUALITY_SIZES = [
      { key: 'A4', label: 'A4 (21 × 29,7 cm)', w: 21,   h: 29.7, target: 250, floor: 180 },
      { key: 'A3', label: 'A3 (29,7 × 42 cm)', w: 29.7, h: 42,   target: 220, floor: 150 },
      { key: 'B2', label: 'B2 (50 × 70 cm)',   w: 50,   h: 70,   target: 180, floor: 120 },
      { key: 'B1', label: 'B1 (70 × 100 cm)',  w: 70,   h: 100,  target: 150, floor: 100 }
    ];

    // Print prep runs the ORIGINAL through Topaz Gigapixel before it goes to the press, so
    // the DPI the customer effectively gets is higher than what they uploaded. This factor
    // converts uploaded DPI -> delivered DPI. It is deliberately below Gigapixel's nominal
    // 2x: upscaled detail is plausible reconstruction, not recorded detail, so claiming the
    // full 2x as "just as good as native" would over-promise. Tune it in theme settings
    // once real customer uploads have been through the pipeline.
    const DEFAULT_UPSCALE_GAIN = 1.6;
    const upscaleGain = (function () {
      const raw = parseFloat(section.getAttribute('data-upscale-gain'));
      // Below 1 would mean upscaling makes things worse; above 3 is not a claim Gigapixel
      // can support on real photographs.
      return (isFinite(raw) && raw >= 1 && raw <= 3) ? raw : DEFAULT_UPSCALE_GAIN;
    })();

    // No upscaler invents information that was never captured. Under this uploaded DPI the
    // answer is "caution" regardless of what the gain arithmetic says.
    const HARD_MIN_NATIVE_DPI = 70;

    function cpString(key, fallback) {
      const s = window.theme && window.theme.strings && window.theme.strings.customPhoto;
      return (s && s[key]) || fallback;
    }

    // ---- Variant resolution (selected size/orientation -> id + price) ------
    let variantData = [], optionNames = [];
    try {
      const vEl = section.querySelector('[data-cp-variants]');
      const nEl = section.querySelector('[data-cp-option-names]');
      if (vEl) variantData = JSON.parse(vEl.textContent);
      if (nEl) optionNames = JSON.parse(nEl.textContent);
    } catch (e) { console.warn('[custom-photo] variant data parse failed', e); }
    const idInput = form.querySelector('input[name="id"]');
    const priceEl = section.querySelector('[data-product-price]');
    const comparePriceEl = section.querySelector('[data-product-compare-price]');
    const saveEl = section.querySelector('[data-product-save]');
    function updateVariant() {
      if (!variantData.length || !optionNames.length) return;
      const sel = optionNames.map(function (_name, i) {
        const r = checkedOption('cp-option' + (i + 1));
        return r ? r.value : null;
      });
      const match = variantData.find(function (v) {
        return v.options && v.options.length === sel.length &&
          v.options.every(function (o, i) { return o === sel[i]; });
      });
      if (!match) return;
      if (idInput) idInput.value = match.id;

      // Poster: the frame is a separate product, but the customer expects the headline price
      // to be what they will pay, so the selected frame's price (for the selected size) is
      // folded in — the canvas shows the same figure naturally, its frame being inside the
      // variant. The size is read from the radios here rather than from the picker, because
      // on a size change this listener runs BEFORE the picker's own (section vs document).
      const sizeRadio = checkedOption(SIZE_RADIO_NAME);
      const picker = section.querySelector('frame-picker');
      const frameDelta = (picker && typeof picker.selectedDeltaCents === 'function')
        ? picker.selectedDeltaCents(sizeRadio ? sizeRadio.value : null)
        : 0;
      const pricing = window.theme && window.theme.customPhotoPricing;
      const canFormat = window.theme && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function';
      const view = (pricing && canFormat && frameDelta > 0)
        ? pricing.compose(match, frameDelta)
        : null;

      if (priceEl && match.price) {
        priceEl.innerHTML = view ? theme.Currency.formatMoney(view.priceCents, theme.settings.moneyFormat) : match.price;
        priceEl.classList.toggle('on-sale', view ? view.onSale : !!match.onSale);
      }
      // Compare price + savings badge mirror the normal PDP's behaviour on variant change.
      const onSale = view ? view.onSale : !!match.onSale;
      if (comparePriceEl) {
        comparePriceEl.innerHTML = onSale
          ? (view ? theme.Currency.formatMoney(view.compareCents, theme.settings.moneyFormat) : match.comparePrice)
          : '';
        comparePriceEl.classList.toggle('hide', !onSale);
      }
      // The "Spar 50%" badge is the merchant's fixed campaign text: only its visibility
      // follows the sale state, the wording is never recomputed (merchant decision).
      if (saveEl) saveEl.classList.toggle('hide', !onSale);
    }

    // A frame tile click changes what the customer pays → same refresh as a size change.
    section.addEventListener('frame:change', updateVariant);

    function currentText() {
      return {
        headline: headlineInput ? headlineInput.value : '',
        subtitle: subtitleInput ? subtitleInput.value : '',
        font: state.font
      };
    }

    // ---- Bake (debounced) → preview + props --------------------------------
    // Serialize bakes on a promise chain so `await runRebake()` ALWAYS resolves
    // after a bake reflecting the LATEST state. A "return early if busy" guard
    // would let the add-to-cart path's requestSubmit() snapshot FormData before
    // the in-flight bake assigned the file — uploading a stale/old image.
    let rebakeTimer = null;
    let bakeChain = Promise.resolve();
    function doBakeOnce() {
      if (!cropper.naturalImage) return;
      return cropper.exportToFile(fileInput, {
        filter: state.filter, border: state.border, text: currentText()
      }).then(function (result) {
        // properties[_crop] is the print backend's re-render recipe. The bare x/y/w/h stay at
        // the top level so an existing parser keeps working; natural/rotation/layout are added
        // so the backend never has to hardcode this file's mat constants and drift from them.
        // NOTE: crop x/y/w/h are in ROTATED source space — rotate the original by
        // properties[_rotation] FIRST, then crop.
        if (cropMetaInput) {
          cropMetaInput.value = JSON.stringify({
            x: result.crop.x, y: result.crop.y, w: result.crop.w, h: result.crop.h,
            natural: result.natural,
            rotation: result.rotation,
            layout: result.layout
          });
        }
        if (propRotation) propRotation.value = String(result.rotation);
        // Attach the untouched original + intended print resolution for the backend
        // re-render. Synced on every bake so it's present before any submit path.
        const origInput = form.querySelector('[data-photo-original-input]');
        if (origInput && cropper.originalFile && typeof DataTransfer === 'function') {
          try { const dt = new DataTransfer(); dt.items.add(cropper.originalFile); origInput.files = dt.files; }
          catch (e) { console.warn('[custom-photo] could not attach original file', e); }
        }
        const printPxInput = form.querySelector('[data-prop-print-px]');
        if (printPxInput) {
          printPxInput.value = (cropper.getAttribute('data-target-px-width') || '') + 'x' + (cropper.getAttribute('data-target-px-height') || '');
        }
        const src = fileInput && fileInput.files && fileInput.files[0];
        if (artImg && src) {
          if (artImg.dataset.objectUrl) URL.revokeObjectURL(artImg.dataset.objectUrl);
          const url = URL.createObjectURL(src);
          artImg.removeAttribute('srcset'); artImg.removeAttribute('sizes');
          artImg.src = url; artImg.dataset.objectUrl = url;
        }
      }).catch(function (err) {
        console.warn('[custom-photo] bake failed', err);
      });
    }
    function runRebake() {
      bakeChain = bakeChain.then(doBakeOnce);
      return bakeChain;
    }
    function scheduleRebake() {
      if (!cropper.naturalImage) return;
      clearTimeout(rebakeTimer);
      rebakeTimer = setTimeout(runRebake, 220);
    }

    // ---- Crop visibility ---------------------------------------------------
    // Editor mode: while a loaded photo is being cropped, mobile hides everything but
    // the editor (config, title, sticky bar — see .cp-editing rules in custom-photo.css)
    // so it feels like "now I'm editing my photo", not a tool mid-page. The class is
    // set on both breakpoints; only the mobile CSS acts on it.
    function syncEditingMode() {
      if (!section.classList) return;
      const wasEditing = section.classList.contains('cp-editing');
      const editing = !cropper.hidden && !!cropper.naturalImage;
      section.classList.toggle('cp-editing', editing);
      // Entering the editor on mobile: bring the whole editor (photo → Bekræft) into
      // view at once — scroll-margin-top on <photo-cropper> keeps it clear of the header.
      if (editing && !wasEditing && mqMobile.matches) {
        cropper.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
    function setCropperVisible(visible) {
      cropper.hidden = !visible;
      if (visible) {
        frameStackHost.style.display = 'none';
        if (cropControls) cropControls.hidden = !cropper.naturalImage;  // only once a photo is loaded
        if (photoActions) photoActions.hidden = true;
        if (addToCart) addToCart.disabled = true;
      } else {
        frameStackHost.style.display = 'block';
        frameStackHost.setAttribute('data-just-revealed', 'true');
        frameStackHost.offsetHeight; // reflow
        requestAnimationFrame(function () { frameStackHost.removeAttribute('data-just-revealed'); });
        if (cropControls) cropControls.hidden = true;
        if (photoActions) photoActions.hidden = false;
        if (addToCart) addToCart.disabled = false;
      }
      syncEditingMode();
    }

    function setReadiness() {
      const drop = cropper.querySelector('[data-photo-cropper-drop]');
      const photoLoaded = drop && drop.hidden;
      if (doneBtn) doneBtn.disabled = !photoLoaded;
    }

    const aiOptin = section.querySelector('[data-ai-optin]');
    const aiLow = section.querySelector('[data-ai-low]');
    const aiStatusDot = section.querySelector('[data-ai-status-dot]');
    const aiStatusText = section.querySelector('[data-ai-status-text]');
    const aiCheckbox = section.querySelector('[data-ai-enhance]');
    // Low quality → orange status + the AI opt-in. Good quality → no box at all (the
    // Kvalitet button in the photo actions already reads "God kvalitet" — one box is enough).
    // The checkbox stays disabled (= never submitted) outside the low state, and re-checks
    // on every new upload so one photo's opt-out never silently carries over to the next.
    function setAiOptinState(lowRes) {
      if (!aiOptin) return;
      aiOptin.hidden = !lowRes;
      aiOptin.setAttribute('data-state', lowRes ? 'low' : 'good');
      if (aiStatusText) {
        aiStatusText.textContent = aiOptin.getAttribute(lowRes ? 'data-quality-low-text' : 'data-quality-good-text') || '';
      }
      if (aiLow) aiLow.hidden = !lowRes;
      if (aiCheckbox) { aiCheckbox.disabled = !lowRes; aiCheckbox.checked = true; }
    }
    // Last verdict seen from the cropper, or null when no image is loaded. <photo-cropper>
    // emits dpi-change from renderImageOnCanvas(), i.e. BEFORE it emits :loaded, so by the
    // time the loaded handler runs this already holds the real verdict for the new photo.
    let lastDpiState = null;
    cropper.addEventListener('photo-cropper:loaded', function (e) {
      setReadiness();
      if (cropControls) cropControls.hidden = false;
      // The customizer renders hidden — empty panels are useless before a photo exists.
      if (customizer) customizer.hidden = false;
      // Prefer the DPI verdict for the SELECTED size — it already fired for this photo (see
      // lastDpiState). meetsFloor is a coarse whole-image pixel count and is only the fallback
      // for the case where no print size is resolvable yet.
      setAiOptinState(lastDpiState ? lastDpiState !== 'ok' : !!(e.detail && e.detail.meetsFloor === false));
      syncEditingMode();
      buildQualityList();
      if (zoomSlider) zoomSlider.value = '1';
      // Desktop: both customizer panels open on upload (the filter panel builds its
      // thumbnails from the live crop, so it isn't empty on first sight). Mobile keeps
      // them closed — the flow stays minimal until the customer asks for more.
      if (!mqMobile.matches) openAccordions();
    });
    // The corner handles resize the crop without touching the zoom slider, so mirror the
    // cropper's (now derived) zoom back into it — a slider that disagreed with the crop made
    // the next drag of it jump the framing.
    cropper.addEventListener('photo-cropper:crop-change', function () {
      if (zoomSlider && cropper.naturalImage) zoomSlider.value = String(cropper.zoom || 1);
    });
    cropper.addEventListener('photo-cropper:dpi-change', setReadiness);
    cropper.addEventListener('photo-cropper:dpi-change', function (e) {
      const st = e.detail && e.detail.state;
      lastDpiState = st || null;
      // Drive the Kvalitet button from the current crop's DPI (replaces the old badge).
      setQualityVerdict(st);
      // …and the AI opt-in with it. This event fires on every crop, zoom, pan and size
      // change, which is the whole point: the offer has to follow the image the customer is
      // actually about to print. Judging it once at upload (the old behaviour) meant zooming
      // deep into a photo silently threw away resolution with nothing said.
      if (st) setAiOptinState(st !== 'ok');
      // The modal is rebuilt live too, so reopening it never shows a stale verdict.
      if (qualityModal && !qualityModal.hidden) buildQualityList();
    });
    cropper.addEventListener('photo-cropper:reset', function () {
      if (artImg) {
        if (artImg.dataset.objectUrl) { URL.revokeObjectURL(artImg.dataset.objectUrl); delete artImg.dataset.objectUrl; }
        artImg.removeAttribute('src');
      }
      setCropperVisible(true);
      closeAccordions();
      if (customizer) customizer.hidden = true;
      if (aiOptin) aiOptin.hidden = true;
      if (aiCheckbox) { aiCheckbox.disabled = true; aiCheckbox.checked = true; }
      if (cropMetaInput) cropMetaInput.value = '';
      if (zoomSlider) zoomSlider.value = '1';
      lastDpiState = null;
    });

    // ---- Crop controls -----------------------------------------------------
    if (zoomSlider) zoomSlider.addEventListener('input', function () {
      if (cropper.setZoom) cropper.setZoom(parseFloat(zoomSlider.value));
    });
    if (rotateBtn) rotateBtn.addEventListener('click', function () {
      if (cropper.rotate90) cropper.rotate90();
      if (zoomSlider) zoomSlider.value = '1';
    });
    if (changeBtn) changeBtn.addEventListener('click', function () { if (cropper.reset) cropper.reset(); });
    if (editBtn) editBtn.addEventListener('click', function () { setCropperVisible(true); });

    updateVariant();  // ensure [name=id] matches the initial selection
    applyAspect();    // ensure crop aspect matches the initial size + orientation

    if (doneBtn) doneBtn.addEventListener('click', async function () {
      await runRebake();           // bake at the confirmed crop
      setCropperVisible(false);
      buildFilterStrip();
    });

    // ---- Filter strip ------------------------------------------------------
    function filterLabel(key) {
      const s = window.theme && window.theme.strings && window.theme.strings.customPhoto;
      if (s && s['filter_' + key]) return s['filter_' + key];
      return key.charAt(0).toUpperCase() + key.slice(1);
    }
    function buildFilterStrip() {
      const PF = window.PosteraPosterFilters;
      if (!filterStrip || !PF || !cropper.naturalImage) return;
      const thumb = cropper.cropThumbnailDataURL(220);
      if (!thumb) return;
      filterStrip.innerHTML = '';
      PF.order.forEach(function (key) {
        const btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'cp-filter' + (key === state.filter ? ' is-selected' : '');
        const img = document.createElement('img');
        img.src = thumb; img.alt = ''; img.style.filter = PF.cssFilter(key);
        const name = document.createElement('span');
        name.className = 'cp-filter__name'; name.textContent = filterLabel(key);
        btn.appendChild(img); btn.appendChild(name);
        btn.addEventListener('click', function () {
          state.filter = key;
          if (propFilter) propFilter.value = key;
          Array.prototype.forEach.call(filterStrip.children, function (c) { c.classList.toggle('is-selected', c === btn); });
          scheduleRebake();
        });
        filterStrip.appendChild(btn);
      });
    }

    // ---- Text + font + border ---------------------------------------------
    if (headlineInput) headlineInput.addEventListener('input', scheduleRebake);
    if (subtitleInput) subtitleInput.addEventListener('input', scheduleRebake);
    section.querySelectorAll('[data-clear]').forEach(function (b) {
      b.addEventListener('click', function () {
        const el = document.getElementById(b.getAttribute('data-clear'));
        if (el) { el.value = ''; scheduleRebake(); el.focus(); }
      });
    });
    fontBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.font = btn.getAttribute('data-font');
        if (propFont) propFont.value = state.font;
        fontBtns.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        scheduleRebake();
      });
    });
    borderBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        state.border = btn.getAttribute('data-border');
        if (propBorder) propBorder.value = state.border;
        borderBtns.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
        scheduleRebake();
      });
    });

    // ---- Accordions --------------------------------------------------------
    // Everything starts closed (nothing to customise before a photo exists), both panels
    // open on upload, and from then on opening one collapses the other — the single-open
    // pattern Posterstore/Desenio use.

    function setAccordion(a, open) {
      a.head.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (a.panel) a.panel.hidden = !open;
      if (open && a.panel && a.panel.querySelector('[data-filter-strip]')) buildFilterStrip();
    }
    function openAccordions() { accordions.forEach(function (a) { setAccordion(a, true); }); }
    function closeAccordions() { accordions.forEach(function (a) { setAccordion(a, false); }); }

    accordions.forEach(function (a) {
      a.head.addEventListener('click', function () {
        const isOpen = a.head.getAttribute('aria-expanded') === 'true';
        if (isOpen) {
          setAccordion(a, false);
        } else {
          accordions.forEach(function (other) { if (other !== a) setAccordion(other, false); });
          setAccordion(a, true);
        }
      });
    });

    // Cover-crop DPI: after scaling the image to fill the print, the tighter axis limits it.
    function coverDpi(W, H, pwIn, phIn) {
      return (W / H >= pwIn / phIn) ? (H / phIn) : (W / pwIn);
    }
    function sizeState(W, H, cmW, cmH, size) {
      // Desenio-style cover-crop min-axis DPI, evaluated at the SELECTED orientation
      // (cmW/cmH already oriented by the caller) — not the optimistic best-of-both —
      // so the modal stays consistent with the live Kvalitet badge.
      const native = coverDpi(W, H, cmW / 2.54, cmH / 2.54);
      if (native < HARD_MIN_NATIVE_DPI) return 'error';
      const delivered = native * upscaleGain;
      if (delivered >= size.target) return 'ok';
      if (delivered >= size.floor) return 'warn';
      return 'error';
    }
    // Customer-facing wording. The internal ok/warn/error scale collapses to two labels
    // rather than three grades of alarm, but the split is at the TARGET DPI, not the floor:
    // anything short of comfortably sharp reads "Kan forbedres" and offers the AI upscale.
    // 'warn' used to be folded in with 'ok', which is why a photo that was fine at A4 and
    // soft at B1 never offered anything, and why zooming in changed nothing on screen.
    // Nothing here blocks add-to-cart — the DPI rating is advisory only.
    // Keep in sync with the two .cp-quality-verdict modifiers in custom-photo.css.
    function verdictFor(st) {
      return (st === 'ok')
        ? { key: 'ok', text: cpString('quality_good', 'Good quality') }
        : { key: 'error', text: cpString('quality_soft', 'Can be improved') };
    }
    function setQualityVerdict(st) {
      const v = verdictFor(st);
      if (qualityBar) qualityBar.setAttribute('data-state', v.key === 'error' ? 'error' : '');
      if (qualityValue) qualityValue.textContent = v.text;
    }

    // The size label shown in the modal is read off the size radio that carries the same
    // size code, so it is translated with the rest of the product instead of frozen here.
    function sizeLabel(code, fallback) {
      const radios = section.querySelectorAll('input[name="' + SIZE_RADIO_NAME + '"]');
      for (let i = 0; i < radios.length; i++) {
        if (radios[i].value.toUpperCase().indexOf(code) !== -1) return radios[i].value;
      }
      return fallback;
    }

    function buildQualityList() {
      if (!qualityList || !cropper.naturalImage) return;
      // Rate the pixels the customer is ACTUALLY printing, not the whole upload. Zooming in
      // throws away resolution, and the Kvalitet button (driven by the cropper's own crop-based
      // DPI) already reflects that — rating the full image here would contradict it.
      const W = cropper.cropW || cropper.naturalImage.naturalWidth;
      const H = cropper.cropH || cropper.naturalImage.naturalHeight;
      const landscape = orientationIsLandscape();
      qualityList.innerHTML = '';
      QUALITY_SIZES.forEach(function (s) {
        // Orient each poster size to the customer's chosen orientation before rating.
        const cmW = landscape ? s.h : s.w;
        const cmH = landscape ? s.w : s.h;
        const st = sizeState(W, H, cmW, cmH, s);
        const v = verdictFor(st);
        const li = document.createElement('li');
        const ico = document.createElement('span');
        ico.className = 'cp-quality-ico cp-quality-ico--' + v.key;
        ico.textContent = v.key === 'ok' ? '✓' : '!';
        const label = document.createElement('span');
        label.textContent = sizeLabel(s.key, s.label);
        const verdict = document.createElement('span');
        verdict.className = 'cp-quality-verdict cp-quality-verdict--' + v.key;
        verdict.textContent = v.text;
        li.appendChild(ico); li.appendChild(label); li.appendChild(verdict);
        qualityList.appendChild(li);
      });
    }
    function openQuality() { if (qualityModal) { buildQualityList(); qualityModal.hidden = false; } }
    function closeQuality() { if (qualityModal) qualityModal.hidden = true; }
    if (qualityBtn) qualityBtn.addEventListener('click', openQuality);
    section.querySelectorAll('[data-quality-close]').forEach(function (el) { el.addEventListener('click', closeQuality); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeQuality(); });

    // ---- Variant option change → id/price (any option) + crop aspect (size) ----
    function applyAspect() {
      const sizeRadio = checkedOption(SIZE_RADIO_NAME);
      if (!sizeRadio) return;
      const sizeVal = sizeRadio.value;
      // Resolve against QUALITY_SIZES so the crop aspect and the quality thresholds can
      // never disagree about which poster size is selected.
      const sz = QUALITY_SIZES.find(function (s) { return sizeVal.indexOf(s.key) !== -1; }) || QUALITY_SIZES[0];
      // Orientation (if the product has it) swaps the print W/H to landscape.
      const landscape = orientationIsLandscape();
      const cmW = landscape ? sz.h : sz.w;
      const cmH = landscape ? sz.w : sz.h;
      const targetW = Math.round(cmW * 300 / 2.54);
      const targetH = Math.round(cmH * 300 / 2.54);
      const ar = targetW + '/' + targetH;
      cropper.setAttribute('data-aspect-ratio', ar);
      cropper.setAttribute('data-target-px-width', targetW);
      cropper.setAttribute('data-target-px-height', targetH);
      cropper.setAttribute('data-print-cm-width', cmW);
      cropper.setAttribute('data-print-cm-height', cmH);
      // Hand the cropper the UPLOADED-DPI thresholds for this size, so its live badge and
      // the Kvalitet button apply the same Topaz-aware model as the modal. Dividing by the
      // gain here keeps the cropper generic — it still compares raw uploaded DPI and needs
      // to know nothing about the print pipeline.
      // ceil, not round: rounding down would put the attribute a hair BELOW the true
      // requirement and let the cropper's badge read "ok" on a DPI the modal still rates
      // as a caution — the two would contradict each other at the boundary.
      cropper.setAttribute('data-dpi-ok', Math.ceil(Math.max(sz.target / upscaleGain, HARD_MIN_NATIVE_DPI)));
      cropper.setAttribute('data-dpi-floor', Math.ceil(Math.max(sz.floor / upscaleGain, HARD_MIN_NATIVE_DPI)));
      if (frameStack) {
        frameStack.style.setProperty('--frame-stack-ar', ar);
        frameStack.setAttribute('data-orientation', landscape ? 'L' : 'P');
        // Required, not defensive: a size change WITHIN one orientation (A3 portrait
        // 3508/4961 -> B2 portrait 5906/8268) changes the print aspect without changing
        // data-orientation, so the element's attributeChangedCallback never fires and the
        // inset art/overlay boxes would keep the previous size's geometry.
        if (typeof frameStack.relayout === 'function') frameStack.relayout();
      }
      // The zoom slider is NOT reset here: <photo-cropper> now re-fits an existing crop to
      // the new aspect instead of throwing it away, so a customer who framed a face and then
      // switched A4 -> B2 keeps their framing. Mirror whatever zoom survived that re-fit.
      if (zoomSlider && cropper.naturalImage) zoomSlider.value = String(cropper.zoom || 1);
      if (cropper.hidden) { scheduleRebake(); buildFilterStrip(); }
    }
    // Listener is on `section` (not the form) so it also catches the orientation radios,
    // which now live in the LEFT column (outside the form DOM, form-associated via form=).
    section.addEventListener('change', function (e) {
      if (!e.target || !e.target.name || !OPTION_RADIO_RE.test(e.target.name)) return;
      updateVariant();                                                                      // any option → id + price
      if (e.target.name === SIZE_RADIO_NAME || e.target.name === ORI_RADIO_NAME) applyAspect();  // size/orientation → crop aspect
    });

    // ---- Add to cart: bake fresh, then submit (frame-picker intercepts) ----
    if (addToCart) addToCart.addEventListener('click', async function () {
      if (!cropper.naturalImage) return;
      clearTimeout(rebakeTimer);
      addToCart.disabled = true;
      try { await runRebake(); } catch (e) {}
      addToCart.disabled = false;
      // `required` on a hidden input is a no-op, so guard explicitly: never submit
      // without a freshly baked file.
      if (!(fileInput && fileInput.files && fileInput.files.length)) return;
      if (form.requestSubmit) {
        form.requestSubmit();
      } else {
        // No requestSubmit (old Safari/iOS 15 and earlier) means a plain form.submit()
        // fires NO submit event at all, so element.frame-picker.js's capture-phase submit
        // listener would never run: the browser would natively POST just the photo,
        // silently drop the frame line, and navigate away. That would ship the customer's
        // order incomplete without any indication anything went wrong, so refuse instead
        // of submitting and fail loudly via the same cart-error host item 2 introduced.
        console.warn('[custom-photo] form.requestSubmit unavailable; refusing to submit natively');
        const strings = window.theme && window.theme.strings && window.theme.strings.customPhoto;
        const message = (strings && strings.cart_error_unsupported_browser) ||
          "Your browser is out of date and can't complete this order. Please update it or use a different browser.";
        const errorHost = section.querySelector('[data-cart-error]');
        if (errorHost) {
          errorHost.textContent = message;
          errorHost.hidden = false;
          errorHost.setAttribute('role', 'alert');
        } else {
          alert(message);
        }
      }
    });

    // ---- Mobile flow (≤768px): Format in the editor + sticky buy bar ------
    // On mobile the Format (portrait/landscape) row lives INSIDE the crop editor next to
    // zoom/rotate and is gone from the main page (Desenio's crop-screen pattern);
    // on desktop it stays under the photo. The radios are form-associated (form=) and
    // their listeners are delegated to `section`, so the node moves freely.
    const formatRow = section.querySelector('[data-cp-format-row]');
    const formatHome = section.querySelector('[data-cp-format-home]');
    const formatEditorSlot = section.querySelector('[data-cp-format-slot-editor]');
    function placeFormatRow() {
      if (!formatRow || !formatHome || !formatEditorSlot) return;
      (mqMobile.matches ? formatEditorSlot : formatHome).appendChild(formatRow);
    }
    if (mqMobile.addEventListener) mqMobile.addEventListener('change', placeFormatRow);
    else if (mqMobile.addListener) mqMobile.addListener(placeFormatRow);
    placeFormatRow();

    // ---- Cookie-consent reopen widget vs. the sticky bar -------------------
    // Pandectes parks its round "reopen consent" button at bottom-left, exactly where the
    // mobile sticky buy bar is, so on this page it lands on top of the price. It can't be
    // removed — withdrawing consent has to stay as easy as giving it — so it gets lifted
    // clear instead. The widget is injected by an external script well after this file runs,
    // and is re-created whenever the banner is reopened, hence the observer.
    //
    // The marker class is what the CSS in custom-photo.css keys off; it lives on <body>
    // because the widget is a sibling of this section, not a descendant.
    document.body.classList.add('cp-has-sticky-bar');
    // Selector belt and braces: Pandectes has shipped the button under a few different
    // names, and a miss here is only a cosmetic overlap, never a broken page.
    const COOKIE_WIDGET_SELECTOR = '.cc-revoke, .pd-cookie-revoke, [class*="cc-revoke"], [id*="pandectes-reopen"]';
    // Symmetric on purpose: an early return on desktop would leave the inline lift set while
    // the viewport was narrow in place forever, and above 768px the sticky bar it compensates
    // for is display:none — so the button would float 84px up over the page content after a
    // rotate to landscape or a window drag. The lift has to be undone, not just skipped.
    function liftCookieWidget() {
      var lift = mqMobile.matches;
      document.querySelectorAll(COOKIE_WIDGET_SELECTOR).forEach(function (el) {
        // Inline, because the widget sets its own inline bottom from its margin setting and
        // a stylesheet rule would lose to it without !important on every property. Removing
        // the property (rather than writing a value) hands control back to the widget's own
        // inline bottom, which is the whole reason we had to go inline in the first place.
        if (lift) el.style.setProperty('bottom', 'calc(84px + env(safe-area-inset-bottom, 0px))', 'important');
        else el.style.removeProperty('bottom');
      });
    }
    liftCookieWidget();
    if (window.MutationObserver) {
      new MutationObserver(liftCookieWidget).observe(document.body, { childList: true, subtree: false });
    }
    if (mqMobile.addEventListener) mqMobile.addEventListener('change', liftCookieWidget);
    else if (mqMobile.addListener) mqMobile.addListener(liftCookieWidget);

    // Sticky bar mirrors the real inline add-to-cart button: label, bag icon, enabled
    // state and price. Pre-upload taps scroll to the uploader instead of dead-ending.
    const stickyBtn = section.querySelector('[data-cp-sticky-btn]');
    const stickyLabel = section.querySelector('[data-cp-sticky-label]');
    const stickyIcon = section.querySelector('[data-cp-sticky-icon]');
    const stickyPrice = section.querySelector('[data-cp-sticky-price]');
    const stickyCompare = section.querySelector('[data-cp-sticky-compare]');
    function syncSticky() {
      if (!stickyBtn) return;
      const photoLoaded = !!cropper.naturalImage;
      const ready = photoLoaded && addToCart && !addToCart.disabled;
      // Never write to stickyBtn itself: it holds the bag SVG as a sibling of the label,
      // and assigning the button's textContent would delete the icon on every sync.
      if (stickyLabel) stickyLabel.textContent = stickyBtn.getAttribute(photoLoaded ? 'data-label-add' : 'data-label-upload') || '';
      // Bag icon only in the real add-to-cart state — in the upload state the tap merely
      // scrolls to the uploader, so a shopping bag beside "Vælg billede" would mislead.
      // toggleAttribute, NOT `.hidden`: the icon is an <svg>, and the `hidden` IDL property
      // is reflected on HTMLElement only — SVGElement never got it. `svg.hidden = false`
      // silently sets a JS expando and leaves the attribute (and the [hidden] CSS rule that
      // matches it) in place, so the icon would stay invisible in both states. The
      // stickyCompare toggle below can keep using `.hidden`; that target is a <span>.
      if (stickyIcon) stickyIcon.toggleAttribute('hidden', !photoLoaded);
      // Theme's .btn.disabled look (grey, like sold-out) — class, not attribute, so the
      // pre-upload tap still scrolls to the uploader.
      stickyBtn.classList.toggle('disabled', !ready);
      stickyBtn.setAttribute('aria-disabled', ready ? 'false' : 'true');
      if (stickyPrice && priceEl) {
        stickyPrice.textContent = priceEl.textContent;
        stickyPrice.classList.toggle('on-sale', priceEl.classList.contains('on-sale'));
      }
      // Strikethrough compare price beside the sticky price, same as the other PDPs.
      if (stickyCompare && comparePriceEl) {
        const txt = comparePriceEl.textContent.trim();
        const show = txt && !comparePriceEl.classList.contains('hide');
        stickyCompare.textContent = show ? txt : '';
        stickyCompare.hidden = !show;
      }
    }
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function () {
        if (!cropper.naturalImage) {
          cropper.scrollIntoView({ behavior: 'smooth', block: 'center' });
          return;
        }
        if (addToCart && !addToCart.disabled) addToCart.click();
      });
      cropper.addEventListener('photo-cropper:loaded', syncSticky);
      cropper.addEventListener('photo-cropper:reset', syncSticky);
      if (window.MutationObserver) {
        if (addToCart) new MutationObserver(syncSticky).observe(addToCart, { attributes: true, attributeFilter: ['disabled'] });
        if (priceEl) new MutationObserver(syncSticky).observe(priceEl, { childList: true, characterData: true, subtree: true });
        if (comparePriceEl) new MutationObserver(syncSticky).observe(comparePriceEl, { childList: true, characterData: true, subtree: true, attributes: true, attributeFilter: ['class'] });
      }
      syncSticky();
    }
  })();
